// extracted by mini-css-extract-plugin
export default {"bottomBar":"BottomBar_bottomBar__WPXYO"};